import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

// Import your newly created external SVG file
import aboutIllustration from '../../assets/illustration.svg'; 

export default function AboutUs() {
  return (
    <section id="about" className="py-5 bg-white">
      <Container>
        <Row className="align-items-center">
          
          {/* Left Side: Loaded from external file for best cache performance */}
          <Col lg={6} className="text-center">
            <img 
              src={aboutIllustration} 
              alt="Office Illustration" 
              className="img-fluid" 
              style={{ width: '80%', maxWidth: '519px', height: 'auto' }} 
            />
          </Col>

          {/* Right Side: Text Content */}
          <Col lg={6} className="ps-lg-5">
            <h6 className="font-rozha display-6 text-success text-uppercase fw-bold mb-2">ABOUT US</h6>
            <hr className="w-25 text-secondary border-2 mb-4" />
            <h2 className="fw-bold text-dark mb-4 display-6">Who We Are</h2>
            <p className="text-secondary lh-lg mb-4 fs-6">
             At TSM Pvt. Ltd, we specialize in innovative and scalable IT services that help businesses grow and stay ahead in a competitive digital landscape. With a team of expert developers, designers, and consultants, we turn ideas into powerful solutions.
            </p>
            <Button style={{ backgroundColor: '#f3d062', borderColor: '#f3d062', color: '#212529' }} className="px-4 py-2.5 fw-bold rounded-pill" href="#services">
              LEARN MORE
              
            </Button>
          </Col>

        </Row>
      </Container>
    </section>
  );
}
